<template>
  <div class="campaigns">
    <div class="inner-content">
      <p>Моля въведете нова парола за Вашия профил.</p>

      <v-form @submit="submitForm">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              filled
              name="password"
              type="password"
              v-model="password"
              label="Парола"
              v-validate="'required|min:6'"
              :error-messages="errors.collect('password')"
              @keyup.enter="submitForm"
              ref="password"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              filled
              name="passwordConfirm"
              type="password"
              v-model="passwordConfirm"
              label="Парола отново"
              v-validate="'required|min:6|confirmed:password'"
              :error-messages="errors.collect('passwordConfirm')"
              @keyup.enter="submitForm"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              color="primary"
              @click="submitForm"
              class="mr-4"
              :loading="loading"
              :disabled="submitDisabled" 
            >
              Изпрати<v-icon class="ml-3">send</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ForgottenPassword',

  data () {
    return {
      userID: this.$route.params.id,
      token: this.$route.params.token,
      password: '',
      passwordConfirm: ''
    }
  },

  methods: {
    submitForm () {
      if (this.submitDisabled) {
        return
      }

      this.$store.commit('setLoading', true)
      this.$store.dispatch('updatePassword', {
        userID: this.userID,
        token: this.token,
        password: this.password
      }).then(() => {
        this.$store.commit('setLoading', false)
        this.$router.push({ name: 'login' })
        this.$store.commit('showAlert', { type: 'success', message: 'Успешно актуализирахте паролата си.' })
      }).catch((err) => {
        this.$store.commit('setLoading', false)
        console.log('err', err)
        this.$store.commit('showError', 'Възникна грешка при запазването на новата Ви парола.')
      })
    }
  },

  computed: {
    submitDisabled () {
      return this.loading || this.password.length === 0 || this.passwordConfirm === 0 ||
        this.password !== this.passwordConfirm
    },
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>
